import React from 'react'
import dayjs from 'dayjs'

import { convertHourFormats } from '@vacationtracker/shared/functions/convert-between-hour-formats'

import FormattedDate from '@vacationtracker/shared/components/formatted-date'
import { HourFormatEnum } from '@vacationtracker/shared/types/user'
import { LocaleEnum } from '@vacationtracker/shared/types/i18n'

const LeaveFormatDate = ({
  locale,
  hourFormat,
  startDate,
  endDate,
  isPartDay,
  partDayStartHour,
  partDayEndHour,
  partDayStartMinute,
  partDayEndMinute,
}: {
  locale: LocaleEnum
  hourFormat: HourFormatEnum
  startDate: string
  endDate: string
  isPartDay: boolean
  partDayStartHour: number
  partDayEndHour: number
  partDayStartMinute?: number
  partDayEndMinute?: number
}) => {
  let formattedDate = (
    <>
      <FormattedDate value={startDate} format="MMMM Do YYYY." locale={locale} /> - <FormattedDate value={endDate} format="MMMM Do YYYY." locale={locale} />
    </>
  )
  if (dayjs(startDate).format('YYYY-MM-DD') === dayjs(endDate as string).format('YYYY-MM-DD') && isPartDay) {
    const { value: startHour, minute: startMinute, amOrPm: startHourAmOrPm } = convertHourFormats(hourFormat, partDayStartHour, partDayStartMinute)
    const { value: endHour, minute: endMinute, amOrPm: endHourAmOrPm } = convertHourFormats(hourFormat, partDayEndHour, partDayEndMinute)
    const startMinuteString = startMinute > 0 ? `:${startMinute}` : ''
    const endMinuteString = endMinute > 0 ? `:${endMinute}` : ''

    const startSuffix = hourFormat === HourFormatEnum.twentyFour ? 'h' : startHourAmOrPm ? ` ${startHourAmOrPm}` : ''
    const endSuffix = hourFormat === HourFormatEnum.twentyFour ? 'h' : endHourAmOrPm ? ` ${endHourAmOrPm}` : ''

    formattedDate = (
      <>
        <FormattedDate value={startDate} format="MMMM Do YYYY." locale={locale} />
        &nbsp; ({startHour}
        {startMinuteString}
        {startSuffix} - {endHour}
        {endMinuteString}
        {endSuffix})
      </>
    )
  }
  if (dayjs(startDate).format('YYYY-MM-DD') === dayjs(endDate as string).format('YYYY-MM-DD') && !isPartDay) {
    formattedDate = <FormattedDate value={startDate} format="MMMM Do YYYY." locale={locale} />
  }

  return formattedDate
}

export default LeaveFormatDate
